module.exports = __webpack_public_path__ + "277d9b44cbbbcb80ac2a5717ce80f9f2.svg";